import { LightIcon, PlusIcon } from "@xola/icons";
import { Alert, Button } from "@xola/ui-kit";
import { Loader } from "common";
import React, { ReactElement } from "react";
import { CatalogItemObject, PickupCatalogItem } from "types";
import { CreatePickupLocationModal } from "./CreatePickupLocationModal";
import { PickupLocationList } from "./PickupLocationList";
import { HeaderToolBarActions } from "@/components/Common/HeaderToolbarActions";
import { ContentLayout } from "@/components/Layout/ContentLayout";
import { useAutoFetchCollection } from "@/hooks/useAutoFetchCollection";
import { useModal } from "@/hooks/useVisibility";

export const PickupLocationPage = () => {
    const {
        isVisible: isVisibleCreatePickupModal,
        show: showCreatePickupModal,
        hide: hideCreatePickupModal,
    } = useModal(false);

    const { data: pickupLocations, isLoading } = useAutoFetchCollection<PickupCatalogItem>(
        "catalogItems",
        { object: CatalogItemObject.PICKUP_CATALOG_ITEM },
        {},
    );

    const isOnlyDeclinedLocation = pickupLocations.length === 1 && pickupLocations[0].isDeclinePickupItem;

    if (isLoading) {
        return <Loader />;
    }

    return (
        <ContentLayout isWide>
            <HeaderToolBarActions>
                <Button
                    className="flex-shrink-0 whitespace-nowrap"
                    color="primary"
                    data-testid="pickup-location-create-button"
                    icon={<PlusIcon />}
                    onClick={showCreatePickupModal}
                >
                    Create Pickup Location
                </Button>
            </HeaderToolBarActions>
            <div className=" mt-5 space-y-4 px-1.5">
                <div className="text-xl font-bold">Pickup Location</div>
                {pickupLocations.length > 0 && !isOnlyDeclinedLocation ? (
                    <PickupLocationList pickupLocations={pickupLocations} />
                ) : (
                    <NoPickUpLocationAlert
                        buttonComponent={
                            <Button
                                className="flex-shrink-0 whitespace-nowrap"
                                color="primary"
                                icon={<PlusIcon />}
                                onClick={showCreatePickupModal}
                            >
                                Create Pickup Location
                            </Button>
                        }
                    />
                )}
            </div>

            <CreatePickupLocationModal isOpen={isVisibleCreatePickupModal} onClose={hideCreatePickupModal} />
        </ContentLayout>
    );
};

const NoPickUpLocationAlert = ({ buttonComponent }: { buttonComponent: ReactElement }) => {
    return (
        <Alert color="primary">
            <div className="flex p-2">
                <LightIcon size="large" />
                <div className="ml-2">
                    <div className="mb-3 flex space-x-2">
                        <span className="text-md font-bold" data-testid="addon-list-no-addons-found">
                            No Pickup Locations
                        </span>
                    </div>
                    <span className="text-base">
                        You do not have any pick-up locations yet. Please create your first location to configure pick
                        up locations.
                    </span>
                </div>
                <div className="ml-auto flex items-center">{buttonComponent}</div>
            </div>
        </Alert>
    );
};
